(() => {
  if (customElements.get('product-video-testimonials')) return;

  class ProductVideoTestimonials extends HTMLElement {
    constructor() {
      super();
      this.prevBtn = this.querySelector('.pvt-prev');
      this.nextBtn = this.querySelector('.pvt-next');
      this.progressFill = this.querySelector('.pvt-progress-fill');
      this.initSwiper();
    }

    updateProgress(swiper) {
      if (!this.progressFill || !swiper) return;
      const total = swiper.slides.length;
      const perView = swiper.params.slidesPerView;
      if (!total || !perView) return;
      const fill = (swiper.progress * (total - perView) + perView) / total;
      this.progressFill.style.width = `${Math.min(fill, 1) * 100}%`;
    }

    initSwiper() {
      const swiperEl = this.querySelector('.pvt-swiper');
      if (!swiperEl) return;

      const init = () => {
        if (this.swiper) return;

        // Add class once Swiper is ready to avoid layout shift
        this.setAttribute('data-initialized', 'true');

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1.44,
          spaceBetween: 16,
          draggable: true,
          grabCursor: true,
          slidesOffsetAfter: 20,
          navigation: {
            prevEl: this.prevBtn,
            nextEl: this.nextBtn,
          },
          on: {
            init: (swiper) => this.updateProgress(swiper),
            progress: (swiper) => this.updateProgress(swiper),
          },
          breakpoints: {
            600: {
              slidesPerView: 1.8,
              spaceBetween: 16,
              slidesOffsetAfter: 20
            },
            750: {
              slidesPerView: 2.2,
              spaceBetween: 12,
              slidesOffsetAfter: 0
            },
            1200: {
              slidesPerView: 2.2,
              spaceBetween: 16,
              slidesOffsetAfter: 0
            }
          }
        });

        this.initVideoControls();
      };

      if (typeof Swiper !== 'undefined') {
        init();
      } else {
        document.addEventListener('swiper:loaded', init, { once: true });
        
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            init();
          }
        }, 100);

        // Cleanup interval if component is removed
        this.addEventListener('remove', () => clearInterval(checkSwiper));
      }
    }

    initVideoControls() {
      const self = this;
      this.querySelectorAll('.pvt-play-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const card = btn.closest('.pvt-card');
          const video = card.querySelector('video');
          
          if (!video) return;

          if (video.paused) {
            self.pauseAll(video);
            video.play().then(() => {
              card.classList.add('playing');
              video.controls = true;
            }).catch(error => {
              console.error("Video play failed:", error);
            });
          } else {
            video.pause();
            card.classList.remove('playing');
            video.controls = false;
          }
        });
      });

      // Handle video events to sync UI
      this.querySelectorAll('video').forEach(video => {
        const card = video.closest('.pvt-card');
        
        video.addEventListener('play', () => {
          card.classList.add('playing');
          video.controls = true;
        });

        video.addEventListener('pause', () => {
          card.classList.remove('playing');
          video.controls = false;
        });

        // Ensure pauseAll is called if something else triggers the play
        video.addEventListener('playing', () => {
          self.pauseAll(video);
        });

        // Toggle UI on video click (if controls are off)
        video.addEventListener('click', (e) => {
          // If native controls are handled, don't interfere
          if (video.controls) return;
          
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      });
    }

    pauseAll(except) {
      this.querySelectorAll('video').forEach(video => {
        if (video !== except && !video.paused) {
          video.pause();
          const card = video.closest('.pvt-card');
          if (card) {
            card.classList.remove('playing');
            video.controls = false;
          }
        }
      });
    }
  }

  customElements.define('product-video-testimonials', ProductVideoTestimonials);
})();
